import type { AuthenticationApi } from "../../api/AuthenticationApi";
import type { AuthLoginRequest } from "../../generated/dto/AuthLoginRequest";
import type { AuthPasswordRequest } from "../../generated/dto/AuthPasswordRequest";
import type { AuthPermissionEscalationRequest } from "../../generated/dto/AuthPermissionEscalationRequest";
import type { AuthRefreshRequest } from "../../generated/dto/AuthRefreshRequest";
import type { AuthResetEmailRequest } from "../../generated/dto/AuthResetEmailRequest";
import type { AuthTokens } from "../../generated/dto/AuthTokens";
import type { JwtToken } from "../../generated/dto/JwtToken";
import type { ProtoLoginResult } from "../../generated/dto/ProtoLoginResult";

export class AuthenticationFrontendService {
  constructor(private readonly api: AuthenticationApi) {}
  async authAsProtoPublic(): Promise<AuthTokens> {
    return this.api.authAsProtoPublic()
  }
  async escalatePermissionsStaff(request: AuthPermissionEscalationRequest): Promise<JwtToken> {
    return this.api.escalatePermissionsStaff(request)
  }
  async escalateSessionStaff(password: string): Promise<JwtToken> {
    return this.api.escalateSessionStaff(password)
  }
  async escalateSessionMember(password: string): Promise<JwtToken> {
    return this.api.escalateSessionMember(password)
  }
  async loginPublic(request: AuthLoginRequest): Promise<AuthTokens> {
    return this.api.loginPublic(request)
  }
  async loginFromProtoMember(request: AuthLoginRequest): Promise<ProtoLoginResult> {
    return this.api.loginFromProtoMember(request)
  }
  async logoutPublic(request: AuthRefreshRequest): Promise<void> {
    return this.api.logoutPublic(request)
  }
  async refreshPublic(request: AuthRefreshRequest): Promise<AuthTokens> {
    return this.api.refreshPublic(request)
  }
  async sendPasswordResetPublic(request: AuthResetEmailRequest): Promise<boolean> {
    return this.api.sendPasswordResetPublic(request)
  }
  async updatePasswordStaff(request: AuthPasswordRequest): Promise<AuthTokens> {
    return this.api.updatePasswordStaff(request)
  }
  async updatePasswordMember(request: AuthPasswordRequest): Promise<AuthTokens> {
    return this.api.updatePasswordMember(request)
  }
}
